import React, { useState } from "react";
import { Table, Badge, Card, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useCTISSchema } from "./CTISSchemaProvider";

export default function CTISMemberStateOverlaysPage() {
  const { screenIndex, loading } = useCTISSchema();
  const [selectedMS, setSelectedMS] = useState("EMA_BASE");
  const navigate = useNavigate();

  if (loading) return <div className="p-5 text-center text-muted">Loading Overlays...</div>;
  if (!screenIndex) return <div className="p-5 text-center text-danger">Error: Could not load EMA Index.</div>;

  return (
    <div className="p-4">
      <Row className="align-items-end mb-4 g-3">
        <Col md={8}>
          <h1 className="h3 mb-1 fw-bold">Member State Overlays</h1>
          <p className="text-muted">Apply country-specific rules to the base CTIS templates.</p>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label className="small fw-bold text-uppercase">Select Member State Context</Form.Label>
            <Form.Select 
              className="border-dark"
              value={selectedMS}
              onChange={(e) => setSelectedMS(e.target.value)}
            >
              <option value="EMA_BASE">EMA Base Blueprint (Standard)</option>
              <option value="DE">Germany (BfArM Overlays)</option>
              <option value="FR">France (ANSM Overlays)</option>
              <option value="ES">Spain (AEMPS Overlays)</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Card className="border-0 shadow-sm">
        <Table hover responsive className="mb-0">
          <thead className="bg-light">
            <tr>
              <th>EMA Section</th>
              <th>Status in {selectedMS}</th>
              <th>Override Logic</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {screenIndex.screens.map((screen) => (
              <tr key={screen.screen_id} className="align-middle">
                <td>
                  <div className="fw-bold">{screen.label}</div>
                  <small className="text-monospace text-muted">{screen.screen_id}</small>
                </td>
                <td>
                  <Badge bg={selectedMS === "EMA_BASE" ? "dark" : "primary"}>
                    {selectedMS === "EMA_BASE" ? "Standard" : "Overlay Applied"}
                  </Badge>
                </td>
                <td>
                  <span className="small text-muted">
                    {selectedMS === "EMA_BASE" 
                      ? "Using core EMA validation rules." 
                      : `Applied ${selectedMS} specific field limits and mandatory flags.`}
                  </span>
                </td>
                <td>
                  <Button 
                    variant="outline-dark" 
                    size="sm"
                    onClick={() => navigate(`/ctis/templates/${screen.screen_id}`)}
                  >
                    View Mockup
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </div>
  );
}